import { render, staticRenderFns } from "./apiuser__list.vue?vue&type=template&id=71c20434"
import script from "./apiuser__list.vue?vue&type=script&lang=js"
export * from "./apiuser__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports